/**
 * Visual and routing metadata for relationship graph node types.
 */

/** @type {Object<string, {label: string, color: string, path?: function(number): string}>} */
export const NODE_TYPE_CONFIG = {
  consignment: {
    label: "Shipment",
    caption: "Shipment",
    color: "#7c3aed",
    iconColor: "#7c3aed",
    dotColor: "#a855f7",
    path: id => `/shipment/po-to/${id}`,
  },
  purchase_order: {
    label: "Purchase order",
    caption: "Orders",
    color: "#2563eb",
    iconColor: "#2563eb",
    dotColor: "#3b82f6",
    path: id => `/orders/purchase/${id}`,
  },
  transfer_order: {
    label: "Transfer order",
    caption: "Transfers",
    color: "#0d9488",
    iconColor: "#0d9488",
    dotColor: "#14b8a6",
    path: id => `/transfer_order/${id}`,
  },
  receipt: {
    label: "Receipt",
    caption: "Receipts",
    color: "#d97706",
    iconColor: "#d97706",
    dotColor: "#f59e0b",
    path: id => `/receipts/${id}`,
  },
  bill: {
    label: "Bill",
    caption: "Bills",
    color: "#dc2626",
    iconColor: "#dc2626",
    dotColor: "#ef4444",
    path: id => `/bill/${id}`,
  },
  prepayment: {
    label: "Prepayment",
    caption: "Prepayments",
    color: "#9333ea",
    iconColor: "#9333ea",
    dotColor: "#a855f7",
    opensInDrawer: true,
  },
  sale_order: {
    label: "Sale order",
    caption: "Sales",
    color: "#059669",
    iconColor: "#059669",
    dotColor: "#10b981",
    path: id => `/sales/order/${id}`,
  },
  sale_invoice: {
    label: "Sale invoice",
    caption: "Invoices",
    color: "#0891b2",
    iconColor: "#0891b2",
    dotColor: "#06b6d4",
    path: id => `/sales/invoice/${id}`,
  },
  sale_quotation: {
    label: "Quotation",
    caption: "Quotes",
    color: "#4f46e5",
    iconColor: "#4f46e5",
    dotColor: "#6366f1",
    path: id => `/quotation/${id}`,
  },
  pick_list: {
    label: "Pick list",
    caption: "Pick lists",
    color: "#ca8a04",
    iconColor: "#ca8a04",
    dotColor: "#eab308",
    path: id => `/picklist/${id}`,
  },
  stock_pack: {
    label: "Pack",
    caption: "Packs",
    color: "#9333ea",
    iconColor: "#9333ea",
    dotColor: "#a855f7",
    path: id => `/pack/${id}`,
  },
  customer_payment: {
    label: "Payment",
    caption: "Payments",
    color: "#16a34a",
    iconColor: "#16a34a",
    dotColor: "#22c55e",
    opensInDrawer: true,
  },
  asn: {
    label: "ASN",
    caption: "ASN",
    color: "#6366f1",
    iconColor: "#6366f1",
    dotColor: "#818cf8",
  },
  supplier_credit_note: {
    label: "Supplier credit",
    caption: "Credits",
    color: "#c2410c",
    iconColor: "#c2410c",
    dotColor: "#f97316",
  },
  files: {
    label: "Files",
    caption: "Files",
    color: "#0284c7",
    iconColor: "#0284c7",
    dotColor: "#0ea5e9",
  },
  tasks: {
    label: "Tasks",
    caption: "Tasks",
    color: "#db2777",
    iconColor: "#db2777",
    dotColor: "#ec4899",
  },
  more: {
    label: "More",
    caption: "More",
    color: "#64748b",
    iconColor: "#64748b",
    dotColor: "#94a3b8",
  },
};

/**
 * @param {string} type
 * @return {{label: string, color: string, path?: function(number): string}}
 */
export function configForNodeType(type) {
  return (
    NODE_TYPE_CONFIG[type] || {
      label: type.replace(/_/g, " "),
      caption: type.replace(/_/g, " "),
      color: "#64748b",
      iconColor: "#64748b",
      dotColor: "#94a3b8",
    }
  );
}
